const formats = [
  {
    icon: 'ri-calendar-check-line',
    title: 'Корпоративный тренинг',
    desc: '1–3 дня интенсивной практической работы с управленческой командой. Максимальная концентрация на отработке лидерских навыков в сжатые сроки.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Модульная программа',
    desc: 'Несколько модулей с практикой между встречами. Позволяет участникам внедрять инструменты в работу и возвращаться с реальными кейсами.',
  },
  {
    icon: 'ri-computer-line',
    title: 'Онлайн-программа',
    desc: 'Дистанционное обучение с практическими заданиями и онлайн-сессиями. Удобно для распределённых команд и компаний из разных городов.',
  },
  {
    icon: 'ri-gamepad-line',
    title: 'Бизнес-игры',
    desc: 'Моделирование управленческих ситуаций и отработка лидерского поведения в игровом формате. Высокая вовлечённость и практическая польза.',
  },
  {
    icon: 'ri-user-voice-line',
    title: 'Индивидуальный коучинг',
    desc: 'Работа с конкретными лидерскими и управленческими задачами руководителя. Персональная проработка ситуаций и индивидуальная обратная связь.',
  },
  {
    icon: 'ri-phone-line',
    title: 'Сопровождение',
    desc: 'Разбор реальных ситуаций после обучения и поддержка внедрения инструментов. Помогает закрепить навыки в ежедневной управленческой практике.',
  },
];

export default function FormatsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Формат тренинга
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-4 max-w-3xl mx-auto leading-relaxed">
          Конкретный формат определяется после обсуждения задачи компании
        </p>
        <p className="text-sm text-gray-500 text-center mb-12 max-w-2xl mx-auto">
          Мы не предлагаем шаблонное решение. Сначала разбираемся в ситуации и только потом предлагаем подходящий формат.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {formats.map((f) => (
            <div key={f.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}